export interface DatedMatch {
  occurredAt?: string | null;
  matchId?: number | null;
  tournamentNumber?: number | null;
}

// A tournament's file number used to double as its place in time: bigger number,
// later match. A kolejka closed in the panel breaks that — it projects a
// tournament numbered -roundId, which sorts below every ingested file and pushes
// the newest matches to the bottom of the list. Time comes from occurredAt now;
// the file number is only a tie-breaker for rows that predate it.
//
// Timestamps carry the day only, so every match of one kolejka ties on time. The
// match id breaks that tie the same way the ELO ledger does (occurredAt, then id),
// which keeps the rendered order identical to the order ratings were computed in.
export function byNewestFirst(a: DatedMatch, b: DatedMatch): number {
  const timeA = matchTime(a);
  const timeB = matchTime(b);

  if (timeA !== timeB) {
    return timeB - timeA;
  }

  if (a.matchId != null && b.matchId != null && a.matchId !== b.matchId) {
    return b.matchId - a.matchId;
  }

  return (b.tournamentNumber ?? 0) - (a.tournamentNumber ?? 0);
}

export function byOldestFirst(a: DatedMatch, b: DatedMatch): number {
  return byNewestFirst(b, a);
}

function matchTime(match: DatedMatch): number {
  if (!match.occurredAt) {
    return 0;
  }

  const parsed = Date.parse(match.occurredAt);

  return Number.isNaN(parsed) ? 0 : parsed;
}
